import React, {useContext} from 'react';
import { Oval } from 'react-loader-spinner';
import {LoaderContext} from '../utils/Contexts';

export default function Loader() {
    const {isLoader, setIsLoader} = useContext(LoaderContext);
    if(!isLoader) return;

    return(        
        <div className='loader'>
            <Oval
                visible={true}
                height="80"
                width="80"
                color="#4fa94d"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
        
    )
}